import type { OnboardingTemplateDocument } from '../OnboardingEmailModal.types';

// Helpers for grouped templates built from the client information request workbooks.
export const questionItem = (
  group: string,
  label: string,
  name: string,
  extra: Partial<OnboardingTemplateDocument> = {}
): OnboardingTemplateDocument => ({ group, label, name, kind: 'question', ...extra });

export const documentItem = (
  group: string,
  label: string,
  name: string,
  extra: Partial<OnboardingTemplateDocument> = {}
): OnboardingTemplateDocument => ({ group, label, name, ...extra });

// Sections that depend on the engagement scope start unchecked.
export const optional = { defaultChecked: false };
